var defines = {

    application : 'icForms',

    selEventToken    : '[name="token"]',
    selPromocode     : '[name="contact-promocode"]',
    selPromocodeInfo : 'span.contact-promocode-info',
    selPromocodeBtn  : '.btn-promocode-submit',

    selMaskPhone: 'input.phone',

    selector_for_open_form : '.icform-button, .icform-link',

    icform_modal           : '.icform-modal',
    icform_modal_form      : '.icform-modal form',

    icform_static          : '.icform-static',
    icform_static_form     : '.icform-static form',

    selector_forms         : '.icform-modal form, .icform-static form',

    selector_for_phanim    : 'input[type="text"], textarea',
    selector_modal_title   : '.modal-title',

    fields: {
        'token': '[name="token"]',
        'fullname': '[name="contact-name"]',
        'email': '[name="contact-email"]',
        'phone': '[name="contact-phone"]',
        'city': '[name="contact-city"]',
        'company': '[name="contact-company"]',
        'jobtitle': '[name="contact-jobtitle"]',
        'promocode': '[name="contact-promocode"]'
    }
};

module.exports = defines;